import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon } from 'antd';
import { getFechamentoReportPerformaceProjectDetalhe } from '@app/api/fechamento';
import ProjetoOverView from '../Relatorios/RelatorioProjectsOverview/projetoOverView';
import { Projeto } from '@app/api/projeto';
import { Button, FormatText, GridView, Widget } from '@digital/ui';
import { SimpleView, CompositeView } from '@digital/ui';


const { Panel } = Collapse;


const DetalheFechamentoProjetoOverView = () => {

    const [fechamentoId, setFechamentoId] = useState<string>();
    const [projetoId, setProjetoId] = useState<string>();
    const [projetoResult, setProjetoResult] = useState<Projeto | undefined>();


    useEffect(() => {
        let fechamentoIdParamens = new URLSearchParams(window.location.search).get('fechamentoId');
        let projetoIdParamens = new URLSearchParams(window.location.search).get('projetoId');
        if (fechamentoIdParamens && projetoIdParamens) {
            setFechamentoId(fechamentoIdParamens);
            setProjetoId(projetoIdParamens);
        }

    }, []);

    useMemo(() => {
        if (fechamentoId && projetoId) {
            getFechamentoReportPerformaceProjectDetalhe(fechamentoId, projetoId).then((data) => {
                setProjetoResult(data);
            });
        }
    }, [projetoId])

    return (
        <SimpleView>
            <GridView noform>
                <CompositeView>
                    <GridView
                        icon="files-new_by_copy"
                        id={`detalhe`}
                        noform title="DADOS GERAIS">
                        <Widget>
                            {projetoResult ?
                                (<ProjetoOverView selectedItem={projetoResult} />)
                                : (<> </>)
                            }
                        </Widget>
                    </GridView>
                </CompositeView>

            </GridView>
        </SimpleView>
    );
};

export default DetalheFechamentoProjetoOverView;
